module.exports = __webpack_public_path__ + "static/img/active8.81633252.png";